import { BaseMapper } from '../shared/base.mapper';
import { ShortCode } from '../../types/shared/shortcode.type';

export class ShortCodeMapper extends BaseMapper<ShortCode> {

}
